import * as React from "react";
const SvgFiRrMoped = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20.5 15c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5m2.5-2a1 1 0 1 0 0-2h-2.5q-.402.001-.797.049l-1.676-4.312c.289.163.618.263.974.263a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1c-.893 0-1.64.589-1.897 1.397A3.97 3.97 0 0 0 13.449 2h-.448a1 1 0 1 0 0 2h.448c.817 0 1.566.513 1.864 1.275l2.447 6.292a7.1 7.1 0 0 0-2.484 1.775l-1.641 1.947a2 2 0 0 1-1.529.711h-.229l-2.194-5.485A3.98 3.98 0 0 0 5.969 8H4c-2.206 0-4 1.794-4 4v2c0 1.533.877 2.852 2.146 3.523A3.5 3.5 0 0 0 2 18.5C2 20.43 3.57 22 5.5 22S9 20.43 9 18.5c0-.169-.016-.335-.04-.5h3.145a4 4 0 0 0 3.059-1.422l1.619-1.923A5 5 0 0 1 20.5 13zM4 16c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h1.969c.822 0 1.552.493 1.856 1.257L9.722 16z"
    />
  </svg>
);
export default SvgFiRrMoped;
